module.exports = __webpack_public_path__ + "img/work.43624e78.svg";